import { DesktopOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import type { MenuProps } from "antd";
import { useTranslation } from "react-i18next";
import { useThemeMode } from "../../Themes/ThemeModeContext";
import type { ThemePreference } from "../../Themes/themeMode";

const CHOICES: ThemePreference[] = ["system", "light", "dark"];
const MENU_ICONS: Record<ThemePreference, JSX.Element> = {
  system: <DesktopOutlined />,
  light: <SunOutlined />,
  dark: <MoonOutlined />,
};

interface ThemeSwitcherProps {
  variant?: "default" | "compact";
}

/** System / Light / Dark picker. The button shows a sun or moon for the theme in use. */
export const ThemeSwitcher = ({ variant = "default" }: ThemeSwitcherProps) => {
  const { t } = useTranslation("common");
  const { preference, resolved, setPreference } = useThemeMode();

  const items: MenuProps["items"] = CHOICES.map((key) => ({
    key,
    icon: MENU_ICONS[key],
    label: t(`theme.${key}`),
  }));
  const onClick: MenuProps["onClick"] = ({ key }) => setPreference(key as ThemePreference);

  return (
    <Dropdown menu={{ items, onClick, selectable: true, selectedKeys: [preference] }} placement="bottomRight" trigger={["click"]}>
      <Button
        type="text"
        size={variant === "compact" ? "small" : "middle"}
        icon={resolved === "dark" ? <MoonOutlined /> : <SunOutlined />}
        aria-label={t("theme.label", { choice: t(`theme.${preference}`) })}
      />
    </Dropdown>
  );
};

export default ThemeSwitcher;
